import React, { useEffect, useRef, useState } from "react";
import {
  ActivityIndicator,
  ScrollView,
  View,
  Image,
  Alert,
  StatusBar,
  BackHandler,
} from "react-native";
import { connect, useDispatch, useSelector } from "react-redux";
import Text from "@components/AppText";
import CategoryHeader from "@components/CMS/CategoryHeader";
import AddnMinBtn from "@components/ProductDisplayUnit/AddnMinBtn";
import KhareedBtn from "@components/ProductDisplayUnit/KhareedBtn";
import SliderBox from "@components/SliderBox";
import colors from "@constants/color";
import metrics, { normalize, width } from "@constants/metrics";
import analytics from "@services/analytics";
import toast from "@utils/toast";
import { completeLeaderPayment, createLeaderPayment } from "@services/api";
import t from "@constants/localization";
import GalleryModal from "../../components/GalleryModal";
import {
  ORDER_FLOW_EVENTS,
  SHARING_EVENTS,
} from "../../constants/analyticsEventsCT";
import { getAddedProductListIds } from "../../reducers/cartReducer";
import CartBottomStrip from "../Home/CartBottomStrip";
import testIds from "@constants/testIds";
import PlaceOrderHOC from "../PlaceOrder/PlaceOrderHOC";
import { actions as configActions } from "@reducers/configReducer";

const PATH = "screens/CustomProductScreen";
const PATH2 = "screens/PlaceOrder";
const formatPrice = (price) => {
  return price.split(".");
};
let trackEventPayload;

const JUSPAY_PAYMENT_STATUS = {
  TIMEOUT: "timeout",
  USER_BACKPRESSED: "backpressed",
};

const CustomProductScreen = (props) => {
  const backHandler = useRef(null);
  const [productDetails, setProductDetails] = useState({});
  const [isProductDetailsFetching, setIsProductDetailsFetching] =
    useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [isGalleryModalOpened, setIsGalleryModalOpened] = useState(false);
  const [orderSubmitting, setOrderSubmitting] = useState(false);
  const [finalProductCount, setFinalProductCount] = useState(0);
  const dispatch = useDispatch();
  let clickedIndex = null;
  const isProductOutOfStock = productDetails.product_status === "OUT OF STOCK";

  const initiateJuspayPaymentPage = (data) => props.processPayment(data);

  const initiateResult = ({ result, event, payload }) => {
    if (payload.status === "success") {
      dispatch(
        configActions.setHyperSDKInitialized({
          hyperSDKInitialized: true,
        }),
      );
    } else {
      dispatch(
        configActions.setHyperSDKInitialized({
          hyperSDKInitialized: false,
        }),
      );
    }
  };

  const showPaymentFailedAlert = (message) => {
    Alert.alert("", message, [
      {
        text: "OK",
        onPress: () => {
          props.navigation.navigate("OtherOrdersList", {});
        },
      },
    ]);
  };

  const processResult = ({ result, event, payload }) => {
    const { error } = result;
    const innerPayload = result.payload || {};
    const status = innerPayload.status || "";
    if (!error) {
      if (status === "cod_initiated") {
        trackEventPayload.payment_method = "COD";
        handleCompleteOrder("YES", ordrId, trackEventPayload);
      } else {
        handleCompleteOrder("NO", ordrId, trackEventPayload);
      }
    } else {
      setOrderSubmitting(false);
      if (status === JUSPAY_PAYMENT_STATUS.USER_BACKPRESSED) {
        showPaymentFailedAlert(t(`${PATH2}/PlaceOrderView/paymentFailed`));
      } else if (status === JUSPAY_PAYMENT_STATUS.TIMEOUT) {
        showPaymentFailedAlert(
          t(`${PATH2}/PlaceOrderView/paymentStillProcessing`),
        );
      } else {
        showPaymentFailedAlert(t(`${PATH2}/PlaceOrderView/paymentFailed`));
      }
    }
  };

  useEffect(() => {
    const { setInitiateResult, setProcessResult } = props;
    setInitiateResult(() => initiateResult);
    setProcessResult(() => processResult);
    backHandler.current = BackHandler.addEventListener(
      "hardwareBackPress",
      onBackPress,
    );
  }, []);

  const onBackPress = () => {
    return false;
  };

  const handleGalleryModalOpen = (index) => {};

  const onShareWhatsapp = async () => {};

  const getDescription = (text) => {
    const newArray = text.split("\\n");
    return newArray.map((el, _) => {
      if (el.startsWith("*")) {
        return (
          <View style={{ flexDirection: "row" }} key={el}>
            <View>
              <Text bold style={{ fontSize: normalize(12) }}>
                {"\u2022"}
              </Text>
            </View>
            <View
              style={{ flex: 1, marginLeft: 5, marginBottom: normalize(5) }}
            >
              <Text
                style={{
                  fontSize: normalize(14),
                  lineHeight: normalize(20),
                }}
              >
                {el.slice(1).trim()}
              </Text>
            </View>
          </View>
        );
      } else {
        return (
          <Text
            key={el}
            style={{
              fontSize: normalize(14),
              lineHeight: normalize(20),
              marginBottom: normalize(3),
            }}
          >
            {el.trim()}
          </Text>
        );
      }
    });
  };

  const handlePlaceOrder = async () => {
    const { sku_id, sku_type } = props.route.params.data;

    let payload = {
      sku_id,
      sku_type,
      total_quantity: finalProductCount,
      language: "hi",
      paymentMethod: "JUSPAY",
      groupBuy: false,
      fromCart: true,
      removeUnavailable: false,
      trackingInfo: {},
    };

    trackEventPayload = {
      payment_method: "JUSPAY",
      total_quantity: finalProductCount,
      total_items: finalProductCount,
    };

    try {
      setOrderSubmitting(true);
      analytics.trackEvent("Payment Widget Clicked", {
        source: "homepage",
      });
      let { data } = await createLeaderPayment(payload);
      ordrId = data.order_id;
      await initiateJuspayPaymentPage(data);
    } catch (e) {
      setOrderSubmitting(false);
    }
  };

  const handleCompleteOrder = async (
    is_cod,
    order_id,
    trackEventPayload = {},
  ) => {
    const { payable_amount: price_tl_single_buy, product_images = [] } =
      props.route.params.data;
    const { total_quantity } = trackEventPayload;
    completeLeaderPayment({ is_cod, order_id })
      .then(async ({ data }) => {
        analytics.trackEvent("SKU Payment Done");
        props.navigation.navigate("PlaceOrderSuccess", {
          inventoryOrder: true,
          splitOrders: [
            {
              order_id: order_id,
              edd: null,
              num_items: 1,
              num_quantity: total_quantity,
              item_photos: product_images,
            },
          ],
          billingDetails: [
            {
              text: t(`${PATH}/Price`),
              value: (price_tl_single_buy * total_quantity).toString(),
            },
            {
              text: t(`${PATH}/Delivery`),
              value: "free",
              amountGreen: true,
            },
          ],
        });
        setOrderSubmitting(false);
      })
      .catch((e) => {
        console.log(e);
        setOrderSubmitting(false);
        analytics.trackEvent(ORDER_FLOW_EVENTS.ORDER_CANCELLED, {
          payload: trackEventPayload,
        });
        Alert.alert("", t(`${PATH}/tryAgain`));
      });
  };

  if (isProductDetailsFetching) {
    return (
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  }

  const {
    id,
    sku_id,
    sku_type,
    geo_hash,
    slug,
    mrp,
    short_name_hi,
    custom_text = "",
    custom_symbol = "",
    price_per_unit,
    short_name_en,
    product_name_hi,
    product_name_en,
    product_description_hi,
    product_description_en,
    payable_amount: price_tl_single_buy,
    collectable_amount,
    paid_amount,
    created_at,
    product_status,
    priority,
    updated_at,
    moq,
    allowed_payment_method,
    product_images = [],
    tags = [],
    amount,
    sku_cta_text,
    force_allow_payment = false,
  } = props.route.params.data;

  return (
    <View
      testID={testIds.Product_Screen_Details}
      style={{
        flex: 1,
        backgroundColor: "white",
      }}
    >
      <StatusBar
        backgroundColor="white"
        barStyle="dark-content"
        animated={true}
      />
      <CategoryHeader
        title={showTitle && short_name_hi}
        shareOnWhatsapp={onShareWhatsapp}
        navigation={props.navigation}
        showWhatsappLogo={false}
        animation={true}
        showSearch={false}
      />
      <ScrollView
        contentContainerStyle={{ minHeight: 100 }}
        onScroll={({ nativeEvent }) => {
          if (nativeEvent.contentOffset.y > 300) {
            if (showTitle) {
              return;
            }
            setShowTitle(true);
          } else if (showTitle) {
            setShowTitle(false);
          }
        }}
      >
        <View>
          <View
            style={{
              opacity: isProductOutOfStock ? 0.5 : 1,
            }}
          >
            <SliderBox
              images={product_images?.map((image) => image)}
              ImageComponentStyle={{
                width: "100%",
                height: normalize(250),
              }}
              resizeMode="contain"
              onCurrentImagePressed={handleGalleryModalOpen}
            />
            <GalleryModal
              handleGalleryModalOpen={handleGalleryModalOpen}
              data={product_images.map((image) => ({ image: image })) || []}
              showModal={isGalleryModalOpened}
              shareOfferOnWhatsapp={() => {}}
              onClickTlOffer={() => {}}
              clickedIndex={clickedIndex}
            />
          </View>
          <View style={{ height: 1, backgroundColor: "rgba(0,0,0,0.1)" }} />
        </View>
        <View>
          <View
            style={{
              paddingVertical: normalize(10),
              paddingHorizontal: normalize(15),
              borderBottomWidth: 1,
              borderBottomColor: "rgba(0,0,0,0.1)",
            }}
          >
            <Text
              numberOfLines={3}
              ellipsizeMode="tail"
              bold
              style={{
                fontSize: normalize(16),
                lineHeight: normalize(24),
                color: "rgba(0,0,0,0.86)",
              }}
            >
              {short_name_hi}
            </Text>
            {!isProductOutOfStock ? (
              <View
                style={{
                  flexDirection: "row",
                  marginTop: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    flex: 1,
                  }}
                >
                  <Text
                    bold
                    style={{
                      fontSize: normalize(18),
                      marginRight: normalize(10),
                      color: "black",
                    }}
                  >
                    ₹{formatPrice(price_tl_single_buy)[0]}
                    {formatPrice(price_tl_single_buy)[1] && (
                      <Text bold style={{ fontSize: normalize(12) }}>
                        .{formatPrice(price_tl_single_buy)[1]}
                      </Text>
                    )}
                  </Text>
                  <Text
                    style={{
                      lineHeight: normalize(16),
                      color: "rgba(0, 0, 0, 0.56)",
                      fontSize: normalize(15),
                      marginTop: normalize(6),
                      textDecorationLine:
                        parseFloat(mrp) !== parseFloat(price_tl_single_buy)
                          ? "line-through"
                          : "none",
                    }}
                  >
                    ₹{mrp}
                  </Text>
                </View>

                {finalProductCount && finalProductCount !== 0 ? (
                  <AddnMinBtn
                    disabled={product_status !== "Active"}
                    onPressPlus={() => {
                      let nextCount = finalProductCount + 1;
                      if (nextCount > moq) {
                        toast.showShortToast(t(`${PATH}/CannotAddProducts`));
                        return;
                      }
                      setFinalProductCount(finalProductCount + 1);
                    }}
                    onPressMinus={() => {
                      setFinalProductCount(finalProductCount - 1);
                    }}
                    // isCartValueLoading={this.state.isCartValueLoading}
                    width={140}
                    count={finalProductCount}
                  />
                ) : (
                  <KhareedBtn
                    testID={testIds.Add_Product_To_Cart}
                    disabled={product_status !== "Active"}
                    onPress={() => {
                      setFinalProductCount(1);
                      // handlePlaceOrder
                    }}
                    isCartValueLoading={false}
                    count={finalProductCount}
                    width={140}
                  />
                )}

                {price_per_unit ? (
                  <View
                    style={{
                      alignItems: "flex-start",
                    }}
                  >
                    <Text
                      numberOfLines={2}
                      style={{
                        fontSize: normalize(13),
                        marginTop: normalize(5),
                        color: "rgba(0,0,0,0.5)",
                      }}
                    >
                      ({price_per_unit})
                    </Text>
                  </View>
                ) : (
                  <></>
                )}
              </View>
            ) : (
              <></>
            )}
          </View>
        </View>

        <View style={{ height: 6, backgroundColor: "#F8F8F8" }} />

        {custom_symbol && custom_text ? (
          <View
            style={{
              flexDirection: "row",
              marginBottom: normalize(10),
              alignItems: "center",
              borderBottomColor: "#F8F8F8",
              borderBottomWidth: 6,
              paddingVertical: normalize(20),
            }}
          >
            <View
              style={{ paddingTop: normalize(2), marginLeft: normalize(12) }}
            >
              <Image
                resizeMode="contain"
                source={{
                  uri: custom_symbol,
                }}
                style={{ height: normalize(20), width: normalize(20) }}
              />
            </View>
            <View
              style={{
                paddingHorizontal: normalize(5),
                flex: 1,
              }}
            >
              <Text
                bold
                style={{
                  color: "rgba(0, 0, 0, 0.56)",
                  fontSize: normalize(14),
                }}
                numberOfLines={2}
                ellipsizeMode="tail"
              >
                {custom_text}
              </Text>
            </View>
          </View>
        ) : (
          <></>
        )}

        {product_description_hi && product_description_hi.length > 1 ? (
          <>
            <View
              style={{
                flex: 1,
                paddingBottom: normalize(10),
              }}
            >
              <View
                style={{
                  paddingVertical: normalize(11),
                  paddingHorizontal: width * 0.04,
                  borderBottomWidth: 1,
                  borderBottomColor: "rgba(0, 0, 0, 0.1)",
                }}
              >
                <Text
                  bold
                  style={{
                    fontSize: normalize(16),
                  }}
                >
                  {t(`${PATH}/prodDescription`)}
                </Text>
              </View>
              <View
                style={{
                  paddingHorizontal: normalize(15),
                  paddingTop: normalize(10),
                }}
              >
                {getDescription(product_description_hi)}
              </View>
            </View>
          </>
        ) : (
          <></>
        )}
      </ScrollView>

      {finalProductCount !== 0 ? (
        <CartBottomStrip
          bottom={{ bottom: 0 }}
          askForLocation={false}
          orderClick={() => {
            handlePlaceOrder();
          }}
          onCrossClick={() => {
            setFinalProductCount(0);
          }}
          total={price_tl_single_buy * finalProductCount}
          item={finalProductCount}
          name={props.user.name}
          force_allow_payment={force_allow_payment}
        />
      ) : null}
    </View>
  );
};

const mapStateToProps = ({
  cart,
  products,
  auth: { user },
  configReducer: { appSettings },
  customer,
}) => {
  return {
    cart,
    oosProducts: products.oosProducts,
    user,
    currentCartSkuIds: getAddedProductListIds(cart),
    selectedContact: customer.selectedContact,
    cartDetails: cart.cartDetails,
    cartItems: cart.cartItems,
    appSettings,
  };
};

export default connect(mapStateToProps)(PlaceOrderHOC(CustomProductScreen));
